import React from 'react';

/**
 * ローディングオーバーレイコンポーネントのプロパティ
 */
export interface LoadingOverlayProps {
  /** ローディング状態 */
  loading: boolean;
  /** ローディングメッセージ */
  message?: string;
}

/**
 * ローディングオーバーレイコンポーネント
 *
 * データロード中やシーン切り替え中に表示されるローディング画面
 */
export function LoadingOverlay({ loading, message = '空間データを読み込み中...' }: LoadingOverlayProps) {
  if (!loading) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed', // HTMLとして固定位置に配置
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: 'white',
        fontSize: '16px',
        zIndex: 1000,
        pointerEvents: 'none' // マウス操作を下のレイヤーに通す
      }}
    >
      <div
        style={{
          width: '280px',
          height: '130px',
          borderRadius: '8px',
          backgroundColor: 'rgba(56, 54, 53, 0.7)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px'
        }}
      >
        <div
          className='loading-spinner'
          style={{
            border: '4px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '50%',
            borderTop: '4px solid white',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite'
          }}
        />
        <div style={{ fontFamily: 'Meiryo, sans-serif' }}>{message}</div>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}
